module.exports = __webpack_public_path__ + "imgs/doctors-icon.46ce2bfca26d07eda698b3763388f91c.svg";